import { render } from "./DisplayDoc.vue?vue&type=template&id=916e2092&scoped=true"
import script from "./DisplayDoc.vue?vue&type=script&lang=js"
export * from "./DisplayDoc.vue?vue&type=script&lang=js"

import "./DisplayDoc.vue?vue&type=style&index=0&id=916e2092&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916e2092"]])

export default __exports__